// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__dZlOV","range":"MonthRangeSwitch_range__1cQ0k","disabled":"MonthRangeSwitch_disabled__302eM"};